import React from 'react';
import Popup from '../../../../components/Popup';
import withMobile from '../../CheckoutRoutes/PackageCheckout/hocs/withMobile';
import { MOBILE_CHECKOUT } from '../../store/constants/classNames';

let mobileContainer;
const desktopContainer = null;

const getContainer = (isMobile) => {
  if (isMobile) {
    mobileContainer =
      mobileContainer || document.getElementsByClassName(MOBILE_CHECKOUT)[0];
    return mobileContainer;
  }
  return desktopContainer;
};
const PopupComp = ({ isMobile, ...rest }) => (
  <Popup container={getContainer(isMobile)} {...rest} />
);

export default withMobile(PopupComp);
